import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Country } from 'containers/common'
import { Select } from 'components/fields'
import { FormData, Module } from 'components/misc'
import { apiOrganizations } from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'

@apiOrganizations()
@connect(null, { modal })
class AwardUnitSelectBlock extends Component {
  static propTypes = {
    data: PropTypes.object,
    errors: PropTypes.object,
    submitFailed: PropTypes.bool.isRequired,
    checkOrganization: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      awardName: '',
      countryId: null
    }
  }

  handleOrganizationChange = ({ label }) => this.setState({ awardName: label })

  handleUnitSelect = () =>
    this.props.change('awards[0].organization.name', this.state.awardName)

  render () {
    const { data, checkOrganization, change, errors, submitFailed } = this.props
    const countryId = get(data, 'person.address.country.id')
    const organizationName = get(data, 'awards[0].organization.name') || '---'
    const hasError = get(errors, 'awards[0].organization.id') && submitFailed

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': () => this.props.modal('modal-change-organization'),
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': '',
        'action': 'Change'
      }
    ]

    return (
      <div>
        <Module
          title="Award Unit"
          primary
          grid
          hasError={hasError}
          buttonDefinition={buttonDefinition}
        >
          <div className="row">
            <div className="col-xs-12">
              <FormData label="Organization">
                {organizationName}
              </FormData>
            </div>
            {hasError &&
              <div className="col-xs-12 base-margin--bottom">
                <span className="form-control-error">
                  Award Unit must be selected
                </span>
              </div>}
          </div>
        </Module>
        <Modal
          id="modal-change-organization"
          action="Select"
          onSubmit={this.handleUnitSelect}
        >
          <Country change={change} />
          <Select
            label="Organization Select"
            name="awards[0].organization.id"
            autocomplete
            disabled={!countryId}
            promise={checkOrganization}
            params={{ countryId }}
            onSelectChange={this.handleOrganizationChange}
          />
        </Modal>
      </div>
    )
  }
}

export default AwardUnitSelectBlock
